export * from '@/agiles/components';

import Vue from 'vue';
import AtcBankAccount from './components/atcBankAccount.vue';
import AtcCommodity from './components/atcCommodity.vue';
import AtcConversion from './components/atcConversion.vue';
import AtcCounterpart from './components/atcCounterpart.vue';
import AtcProjectItem from './components/atcProjectItem.vue';
import AtcSegment from './components/atcSegment.vue';
import AtcSKU from './components/atcSKU.vue';
import AtcTaxCode from './components/atcTaxCode.vue';
import AtcCategory from './components/atcCategory.vue';
import BtnStockSchedule from './components/btnStockSchedule.vue';
import PopStockSchedule from './components/popStockSchedule.vue';
import GrdVoucherItem from './components/grdVoucherItem.vue';
import PnlNotificationSetting from './components/pnlNotificationSetting.vue';
import PnlReserveItems from './components/pnlReserveItems.vue';
import RptSalesAnalyse from './views/Report/RptSalesAnalyse.vue';
import RptSalesSummary from './views/Report/RptSalesSummary.vue';
import RptPurchaseSummary from './views/Report/RptPurchaseSummary.vue';
import RptCommodityAnalyse from './views/Report/RptCommodityAnalyse.vue';
import RptSalesDeliverySchedule from './views/Report/RptSalesDeliverySchedule.vue';
import RptPurchaseDeliverySchedule from './views/Report/RptPurchaseDeliverySchedule.vue';
import RptSalesJournal from './views/Report/RptSalesJournal.vue';
import RptPurchaseJournal from './views/Report/RptPurchaseJournal.vue';
import RptCommodityJournal from './views/Report/RptCommodityJournal.vue'
import RptChargeJournal from './views/Report/RptChargeJournal.vue'
import RptStockBalance from './views/Report/RptStockBalance.vue'
import RptReceivePaymentScheduled from './views/Report/RptReceivePaymentScheduled.vue'
import RptReceivePaymentResult from './views/Report/RptReceivePaymentResult.vue'
import RptSendPaymentScheduled from './views/Report/RptSendPaymentScheduled.vue'
import RptSendPaymentResult from './views/Report/RptSendPaymentResult.vue'
import RptSupplementCommodity from './views/Report/RptSupplementCommodity.vue'
import RptPurchaseCashBalance from './views/Report/RptPurchaseCashBalance.vue'
import RptSalesCashBalance from './views/Report/RptSalesCashBalance.vue'
import RptSlipJournalItem from './views/Report/RptSlipJournalItem.vue'
import RptTransactionSummary from './views/Report/RptTransactionSummary.vue';
import BarcodeDialog from './views/Transaction/components/BarcodeDialog.vue'
import BookSales from './views/Transaction/components/BookSalesDialog.vue'
import BulkBookSales from './views/Transaction/components/BulkBookSalesDialog.vue'
import CreatePurchaseOrder from './views/Transaction/components/CreatePurchaseOrderDialog.vue'
import CreatePurchaseOrderFromCommodity from './views/Transaction/components/CreatePurchaseOrderFromCommodityDialog.vue'
import CreatePurchaseDelivery from './views/Transaction/components/CreatePurchaseDeliveryDialog.vue'
import DirectAccessDialog from './views/Transaction/components/DirectAccessDialog.vue'
import ShippingInstruction from './views/Transaction/components/ShippingInstructionDialog.vue'
import ReturnDelivery from './views/Transaction/components/ReturnDeliveryDialog.vue'
import CancelBookSales from './views/Transaction/components/CancelBookSalesDialog.vue'
import UpdateDeliveryDate from './views/Transaction/components/UpdateDeliveryDateDialog.vue'

import Counterpart from './views/Master/Counterpart.vue'
import Commodity from './views/Master/Commodity.vue'
import SKU from './views/Master/SKU.vue'
import Conversion from './views/Master/Conversion.vue'
import Price from './views/Master/Price.vue'
import ShelfNo from './views/Master/ShelfNo.vue'
import AssemblyComponent from './views/Master/Component.vue'
import PartneredTenant from './views/Master/PartneredTenant.vue'
import PartneredUser from './views/Master/PartneredUser.vue'

import SalesOrderItem from './views/Transaction/SalesOrderItem.vue'
import SalesDeliveryItem from './views/Transaction/SalesDeliveryItem.vue'
import ProjectItem from './views/Transaction/ProjectItem.vue'
import PurchaseOrderItem from './views/Transaction/PurchaseOrderItem.vue'
import PurchaseDeliveryItem from './views/Transaction/PurchaseDeliveryItem.vue'
import StockBalance from './views/Journal/StockBalance.vue'
import StockReplenishmentCommodity from './views/Journal/StockReplenishmentCommodity.vue'
import StockRelocationItem from './views/Journal/StockRelocationItem.vue'
import StockTakingItem from './views/Journal/StockTakingItem.vue'
import StockTransferItem from './views/Journal/StockTransferItem.vue'

import SalesOrder from './views/Transaction/SalesOrder.vue'
import SalesDelivery from './views/Transaction/SalesDelivery.vue'
import PurchaseOrder from './views/Transaction/PurchaseOrder.vue'
import PurchaseDelivery from './views/Transaction/PurchaseDelivery.vue'

Vue.component('AtcBankAccount',AtcBankAccount);
Vue.component('AtcCommodity',AtcCommodity);
Vue.component('AtcConversion',AtcConversion);
Vue.component('AtcCounterpart',AtcCounterpart);
Vue.component('AtcProjectItem',AtcProjectItem);
Vue.component('AtcSegment',AtcSegment);
Vue.component('AtcSKU',AtcSKU);
Vue.component('AtcTaxCode',AtcTaxCode);
Vue.component('AtcCategory',AtcCategory);
Vue.component('BtnStockSchedule',BtnStockSchedule);
Vue.component('PopStockSchedule',PopStockSchedule);
Vue.component('GrdVoucherItem',GrdVoucherItem);
Vue.component('PnlNotificationSetting',PnlNotificationSetting);
Vue.component('PnlReserveItems',PnlReserveItems);
Vue.component('RptSalesAnalyse',RptSalesAnalyse);
Vue.component('RptSalesSummary',RptSalesSummary);
Vue.component('RptPurchaseSummary',RptPurchaseSummary);
Vue.component('RptCommodityAnalyse',RptCommodityAnalyse);
Vue.component('RptSalesDeliverySchedule',RptSalesDeliverySchedule);
Vue.component('RptPurchaseDeliverySchedule',RptPurchaseDeliverySchedule);
Vue.component('RptSalesJournal',RptSalesJournal);
Vue.component('RptPurchaseJournal',RptPurchaseJournal);
Vue.component('RptCommodityJournal',RptCommodityJournal);
Vue.component('RptChargeJournal',RptChargeJournal);
Vue.component('RptStockBalance',RptStockBalance);
Vue.component('RptReceivePaymentScheduled',RptReceivePaymentScheduled);
Vue.component('RptReceivePaymentResult',RptReceivePaymentResult);
Vue.component('RptSendPaymentScheduled',RptSendPaymentScheduled);
Vue.component('RptSendPaymentResult',RptSendPaymentResult);
Vue.component('RptSupplementCommodity',RptSupplementCommodity);
Vue.component('RptPurchaseCashBalance',RptPurchaseCashBalance);
Vue.component('RptSalesCashBalance',RptSalesCashBalance);
Vue.component('RptSlipJournalItem',RptSlipJournalItem);
Vue.component('RptTransactionSummary',RptTransactionSummary);
Vue.component('CreatePurchaseOrder',CreatePurchaseOrder);
Vue.component('CreatePurchaseOrderFromCommodity',CreatePurchaseOrderFromCommodity);
Vue.component('CreatePurchaseDelivery',CreatePurchaseDelivery);
Vue.component('DirectAccessDialog',DirectAccessDialog);
Vue.component('BarcodeDialog',BarcodeDialog);
Vue.component('BookSales',BookSales);
Vue.component('BulkBookSales',BulkBookSales);
Vue.component('ShippingInstruction',ShippingInstruction);
Vue.component('ReturnDelivery',ReturnDelivery);
Vue.component('CancelBookSales',CancelBookSales);
Vue.component('UpdateDeliveryDate',UpdateDeliveryDate);

Vue.component('Counterpart',Counterpart);
Vue.component('Commodity',Commodity);
Vue.component('SKU',SKU);
Vue.component('Conversion',Conversion);
Vue.component('Price',Price);
Vue.component('ShelfNo',ShelfNo);
Vue.component('AssemblyComponent',AssemblyComponent);
Vue.component('PartneredTenant',PartneredTenant);
Vue.component('PartneredUser',PartneredUser);

Vue.component('SalesOrderItem',SalesOrderItem);
Vue.component('SalesDeliveryItem',SalesDeliveryItem);
Vue.component('ProjectItem',ProjectItem);
Vue.component('PurchaseOrderItem',PurchaseOrderItem);
Vue.component('PurchaseDeliveryItem',PurchaseDeliveryItem);
Vue.component('StockBalance',StockBalance);
Vue.component('StockReplenishmentCommodity',StockReplenishmentCommodity);
Vue.component('StockRelocationItem',StockRelocationItem);
Vue.component('StockTakingItem',StockTakingItem);
Vue.component('StockTransferItem',StockTransferItem);

Vue.component('SalesOrder',SalesOrder);
Vue.component('SalesDelivery',SalesDelivery);
Vue.component('PurchaseOrder',PurchaseOrder);
Vue.component('PurchaseDelivery',PurchaseDelivery);

export { AtcBankAccount,AtcCommodity,AtcConversion,AtcCounterpart,AtcProjectItem,AtcSegment,AtcSKU,AtcTaxCode,AtcCategory,BtnStockSchedule,PopStockSchedule,GrdVoucherItem,PnlNotificationSetting,PnlReserveItems,
             RptSalesAnalyse,RptSalesSummary,RptPurchaseSummary,RptCommodityAnalyse,
             RptSalesDeliverySchedule,RptPurchaseDeliverySchedule,RptSalesJournal,RptPurchaseJournal,RptCommodityJournal,
             RptChargeJournal,RptStockBalance,RptSupplementCommodity,
             RptReceivePaymentScheduled,RptReceivePaymentResult,RptSendPaymentScheduled,RptSendPaymentResult, RptPurchaseCashBalance,RptSlipJournalItem,RptSalesCashBalance,RptTransactionSummary,
             CreatePurchaseOrder,CreatePurchaseOrderFromCommodity,CreatePurchaseDelivery,DirectAccessDialog, BarcodeDialog ,BookSales,BulkBookSales,ShippingInstruction, ReturnDelivery, CancelBookSales,UpdateDeliveryDate,
             
             Counterpart,Commodity,SKU,Conversion,Price,ShelfNo,AssemblyComponent,PartneredTenant,PartneredUser,
             SalesOrderItem,SalesDeliveryItem,ProjectItem,PurchaseOrderItem,PurchaseDeliveryItem,StockBalance,StockReplenishmentCommodity,StockRelocationItem,StockTakingItem,StockTransferItem,
             SalesOrder,SalesDelivery,PurchaseOrder,PurchaseDelivery,
             };
